import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import nephrology from "../../practices_images/nephrology.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const Nephrology = () => {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="cap-container">
        <h1>Nephrology</h1>

        <div className="cap-section">
          <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Supporting care for complex and chronic conditions</h3>
            <p>
              Nephrology practices operate in one of the most complex areas of medicine. Long term patient relationships, chronic disease management, and highly regulated reimbursement models place significant demands on clinical, operational, and financial systems.
            </p>
            <p>
              We work with nephrology practices to bring clarity and structure to this complexity, supporting care teams as they manage high acuity patients across multiple settings.
            </p>

            <h3>The Complexity of Nephrology Care</h3>
            <p>
              Nephrology requires precise documentation, consistent patient tracking, and strict adherence to regulatory and payer requirements. Dialysis coordination, chronic kidney disease management, and transplant related care introduce layers of operational and financial complexity that extend beyond the clinical encounter.            </p>
            <p>
              Without strong systems in place, these pressures can strain staff, disrupt workflows, and impact financial performance.
            </p>

            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help nephrology practices strengthen the operational foundations that support high quality care.
              </p>
              <p>
                Our work focuses on improving documentation and coding accuracy, reinforcing billing and revenue cycle processes, supporting compliance with Medicare and commercial payer requirements, and aligning workflows across clinical, administrative, and financial teams.
              </p>
              <p>
                We take a practical approach that respects the realities of nephrology care delivery.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Enabling Consistency and Control">
              <p>
                Our goal is to help practices operate with greater consistency, visibility, and control.
              </p>
              <p>
                By strengthening operational and financial processes, we support improved revenue predictability, reduced administrative burden, and more reliable coordination of care. This allows clinicians and staff to focus on managing complex patient needs with confidence.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Looking Ahead">
              <p>
                As nephrology care continues to evolve, the need for reliable systems and disciplined execution becomes even more critical.
                We partner with practices to build the structure and stability required to support patients over the long term.
                Let’s talk about how your practice can move forward with clarity and purpose.
              </p>
            </CollapsibleSection>
          </div>

          {/* Image Section */}
          <div className="image-container">
            <img src={nephrology} alt="Nephrology" />
          </div>

        </div>
      </div>
    </motion.div>
  );
};

export default Nephrology;
